<template>
  <video ref="videoPlayer" class="video-js"></video>
</template>

<script>
	import { ajaxGet,ajaxPost } from "../../../ajax";
import videojs from "video.js";
  import {apiUrl} from "@/main";
require("video.js/dist/video-js.css");

export default {
  name: "AudioPlayer",
  props: {
	options: {
		type: Object,
		default() {
			return {};
		}
	}
  },
  data() {
	return {
	  player: null
	};
  },
  mounted() {
	this.assignmentFlag = (this.$router.history.current.query.Assignment) ? 'assignments' : 'content';
	console.log("-->>", this.assignmentFlag, this.options.id);
	this.sdat = undefined;
		ajaxGet(apiUrl()+ "/"+this.assignmentFlag+"/video/" + this.options.vvid + "",
			(dat) => {
				console.log("DATA", dat);
				this.options.sources.src = dat.videoURL;
				if(this.assignmentFlag === "assignments"){
					this.videoId = this.$router.history.current.query.Assignment;
					//get student data
					ajaxGet(apiUrl()+this.assignmentFlag+"/" + this.options.vvid + "/results",
						(dat) => {
							console.log("DATA", dat);
							this.sdat = dat;
							this.initVideo();
						},
						(err) => {
							console.log("ERR", err);
							this.sdat = undefined;
							this.initVideo();
						}, localStorage.token);
				}else{
					this.initVideo();
				}
				// this.initVideo();
			},
			(err) => {
				console.log("ERR", err);
				// this.sdat = undefined;
				// this.initVideo();
			}, localStorage.token);

	// this.player.on("play", this.updateTime);
  },
  beforeDestroy() {
	if (this.player) {
		this.player.dispose();
	}
  },
  methods:{
  	updateTime(e){
		var sendUpdate = true;
		if(e.type == "timeupdate"){
			this.totaltimeupdates += 1;
			if(this.totaltimeupdates >= 60){
				this.totaltimeupdates = 0;
			}else{
				sendUpdate = false;
			}
		}
		if(sendUpdate){
			var ansObj = {
				video_time: e.target.player.currentTime(),
				video_total_time: e.target.player.duration(),
				last_viewed_on: Date.now()
			}
			console.log("UPDATE CALLED", ansObj);
			this.postResult(ansObj);
		}
	  },
	  postResult(aobj){
	  	var diff = Date.now() - this.lastupdate;
	  	console.log("SDAT:", this.sdat);
	  	// console.log("COMPARE:", aobj.video_time, this.sdat.data.video_time);
	  	var vt = (this.sdat) ? this.sdat.data.video_time : 0;
	  	if(diff > 5000 && aobj.video_time > vt){
	  		this.lastupdate = Date.now();
	  		console.log("POSTING", diff);
	  		ajaxPost(apiUrl() +"/assignments/" + this.options.vvid, {
	  			Data: aobj
	  		},
	  		(suc) => {
				console.log("Posted assignment:", suc);
			},
			(err) => {
				console.log("Error :", err)
			}, localStorage.token);
	  	}
	  },
	  initVideo(){
	  	var x = this;
	  	console.log("TTTT", this.sdat);
		  console.log(">>>", this.options.sources.src);
		this.player = videojs(
			this.$refs.videoPlayer,
			{
				autoplay: true,
				controls: true,
				sources: [
					{
						src: this.options.sources.src,
						type: "video/mp4"
					}
				]
			},
			function onPlayerReady() {
				// console.log("PLAYER READY", x.sdat);
				if(x.sdat)
					this.currentTime(x.sdat.data.video_time);
				else
					this.currentTime(0);
			}
		);
		if(this.assignmentFlag === "assignments"){
			this.player.on("play", (e) => this.updateTime(e));
			this.player.on("pause", (e) => this.updateTime(e));
			this.player.on("timeupdate", (e) => this.updateTime(e));
			this.totaltimeupdates = 0;
			this.lastupdate = 0;
		}
	  }
  }
};
</script>